import * as React from "react";
import { IFormType } from "../../../model/formconfiguration/FormType";
import Dialog from "../../components/app/Dialog";

const CancelFormVersionDialog = ({
  cancelFormVersionDialogVisible,
  hideCancelFormVersionDialog,
  translate,
  cancelFormVersion,
  rowData
}: {
  cancelFormVersionDialogVisible: boolean;
  hideCancelFormVersionDialog(): void;
  translate: any;
  cancelFormVersion(roleTypeCode: string): void;
  rowData: IFormType;
}) => {
  return (
    <Dialog
      title={translate("cancel_form_version_dialog.title")}
      modalVisible={cancelFormVersionDialogVisible}
      onCancel={(e) => hideCancelFormVersionDialog()}
      onOk={(e) => {
        cancelFormVersion(rowData.code);
        hideCancelFormVersionDialog();
      }}
      okText={translate("cancel_form_version_dialog.cancel_version")}
      cancelText={translate("cancel_form_version_dialog.cancel")}
      okButtonProps={{ type: "danger" }}
    >
      {translate("cancel_form_version_dialog.text")}
    </Dialog>
  );
};

export default CancelFormVersionDialog;
